import { ChangeEvent, KeyboardEvent, MouseEvent, useRef } from "react";
import { searchFormString, searchCodeModalFormString, searchFormDefaultString, searchFieldWidth, searchLabelStyle, inputFormHeightOption, } from "src/components/common/common";
import { XButtonForm } from "../XButtonForm";

interface Props {
	label: string;
	titleWidth?: number;
	value: string;
	valueLabel: string;
	handleFoucsId?: string;
	className?: string;
	onChange: (e: ChangeEvent<HTMLInputElement>) => void;
	onDoubleClick: (e: MouseEvent<HTMLInputElement>) => void;
	onKeyDown: (e: KeyboardEvent<HTMLInputElement>) => void;
	wrapperOption?: {
		wrapperStyle: string;
		titleStyle: string;
		codeInputStyle: string;
		nameTagStyle: string;
	};
	valueLabelless?: boolean;
}

export const SearchCodeModalForm = ( props: Props ) => {

	const {
		label,
		titleWidth,
		value,
		valueLabel,
		handleFoucsId,
		className,
		onChange,
		onDoubleClick,
		onKeyDown,
		wrapperOption = {
			wrapperStyle: "w-[500px] min-w-[500px] mr-[10px]",
			titleStyle: "w-[150px] min-w-[150px] text-left",
			codeInputStyle: "w-[190px] min-w-[190px]",
			nameTagStyle: "w-[200px] min-w-[200px] text-left",
		},
		valueLabelless = false,
	} = props;

	const inputRef = useRef<HTMLInputElement>(null);
	
	return (
		<>
		<div className={`${ searchFormString } ${className} ${searchFieldWidth} ${wrapperOption.wrapperStyle} cursor-pointer`}
			style={titleWidth ? { width: "max-content" } : undefined}
			// onClick={onDoubleClick}
		>
				<p
					className={`${searchLabelStyle} ${wrapperOption.titleStyle} cursor-pointer`}
					style={titleWidth ? { width: titleWidth, minWidth: titleWidth } : undefined}
					title={label}
				>
					{label}
				</p>
				<div className="relative">
				<input className={`${ searchCodeModalFormString } ${wrapperOption.codeInputStyle}`}
					id={handleFoucsId}
					name={handleFoucsId}
					value={value}
					ref={inputRef}
					onClick={(e) => e.stopPropagation()}
					onChange={onChange}
					onDoubleClick={onDoubleClick}
					onKeyDown={onKeyDown} />
					<XButtonForm
						className="right-[2px]"
						onClick={() => {
							if (inputRef.current && onChange) {
								const event = { target: { name: inputRef.current.name, value: '' } } as React.ChangeEvent<HTMLInputElement>;
								onChange(event);
							}
						}}
					/>
				</div>
				{!valueLabelless && (
					<p className={`${ inputFormHeightOption }
						${searchFormDefaultString} bg-gray-disable px-[6px] py-[2px] 
						${wrapperOption.nameTagStyle} h-[24px] text-left flex items-center rounded-[6px]`}
						>
						{valueLabel}
					</p>
				)}
			</div>
		</>
	)
}
